import { buildApiUrl } from '../../config/api';
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const perfilesPermitidos = [
  'Administrador', 'Asesor comisionista', 'Asesor', 'Vendedor', 'Jefe', 'Callcenter', 'Back', 'BackRecupero', 'Calidad', 'Reclutador', 'Recursos Humanos', 'Consultas', 'Gerente', 'rrhh', 'Supervisor'
];

const ConsultaUsuarios = ({ onConsultar, token }) => {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const fetchUsuarios = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(buildApiUrl('/api/users'), {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Filtrar solo usuarios con perfiles permitidos
      const usuariosFiltrados = response.data.users.filter(u => 
        perfilesPermitidos.includes(u.perfil_nombre)
      );
      
      setUsuarios(usuariosFiltrados);
    } catch (err) {
      setError('Error al cargar usuarios');
      setUsuarios([]);
    } finally {
      setLoading(false);
    }
  };

  const getEstadoClass = (estado) => {
    switch ((estado || '').toUpperCase()) {
      case 'ACTIVO':
        return 'usuarios-estado-activo';
      case 'BAJA':
        return 'usuarios-estado-baja';
      default:
        return 'usuarios-estado-pendiente';
    }
  };

  return (
    <div className="usuarios-table-container">
      <div className="usuarios-table-header">
        <h2 className="usuarios-table-title">Consulta de Usuarios</h2>
        {error && <div className="error-message">{error}</div>}
      </div>
      <div className="usuarios-table-wrapper">
        <table className="usuarios-table">
          <thead>
            <tr>
              <th>Tipo Documento</th>
              <th>Número</th>
              <th>Nombres y Apellidos</th>
              <th>Celular</th>
              <th>Perfil</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="loading-cell">
                  <div className="loading">Cargando usuarios...</div>
                </td>
              </tr>
            ) : usuarios.length === 0 ? (
              <tr>
                <td colSpan="7" className="no-data">
                  No hay usuarios para consultar
                </td>
              </tr>
            ) : (
              usuarios.map(usuario => (
                <tr key={usuario.id}>
                  <td>{usuario.tipo_documento || '-'}</td>
                  <td>{usuario.numero_documento || '-'}</td>
                  <td>{usuario.nombres || usuario.usuario || '-'}</td>
                  <td>{usuario.celular || '-'}</td>
                  <td>{usuario.perfil || '-'}</td>
                  <td>
                    <span className={`usuarios-estado ${getEstadoClass(usuario.estado)}`}>
                      {usuario.estado || 'PENDIENTE'}
                    </span>
                  </td>
                  <td>
                    <button
                      className="usuarios-btn usuarios-btn-primary usuarios-btn-sm"
                      onClick={() => onConsultar(usuario)}
                    >
                      CONSULTAR
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ConsultaUsuarios; 